import styled, { keyframes } from 'styled-components';

export const UploadInputWrapper = styled.div`
  width: 100%;
  font-family: ${({ theme }) => theme.fonts.secondary};
  svg.upload {
    display: block;
    margin: 10px auto;
    fill: ${({ theme }) => theme.colors.main};
    box-sizing: content-box;
    padding: 16px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 2px solid ${({ theme }) => theme.colors.main};
  }
  span {
    display: block;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: center;
  }
  input[type='file'] {
    display: none;
  }
  button {
    display: block;
    margin: 14px auto 0px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
  }
`;

export const UploadedList = styled.div`
  height: 110px;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 5px;
    background: ${({ theme }) => theme.colors.textLight};
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.text};
    border-radius: 15px;
    height: 2px;
  }
  @media (max-width: 570px) {
    padding: 10px;
  }
`;

export const UploadedListFile = styled.div<{ status: string }>`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0em;
  text-align: left;
  color: ${({ theme }) => theme.colors.text};
  padding: 5px 3px;
  width: 100%;
  position: relative;
  div.name {
    width: ${props =>
      props.status !== 'error' ? `calc(100% - 25px)` : `calc(100% - 50px)`};
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
    vertical-align: middle;
    white-space: nowrap;
  }
  div.iconError,
  div.icon {
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    margin: 0 0 0 5px;
    cursor: pointer;
    svg.notUploaded,
    svg.uploaded {
      height: 24px;
      width: 24px;
      margin: -2px;
    }
    svg.notUploaded {
      fill: ${({ theme }) => theme.colors.error};
    }
    svg.uploaded {
      fill: ${({ theme }) => theme.colors.success};
    }
  }
  div.iconError:hover div.hover {
    display: flex;
  }
  svg {
    margin: 0px;
  }
  div.hover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    color: #ffffff;
    background: #000000;
    opacity: 0.8;
    display: none;
    align-items: center;
    justify-content: center;
    font-family: ${({ theme }) => theme.fonts.secondary};
    font-size: 9px;
    line-height: 12px;
    letter-spacing: 0em;
  }
`;

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Loading = styled.div`
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);
  background-image: conic-gradient(
    from 180deg at 50% 50%,
    #fff 0deg,
    #0cc841 360deg
  );
  width: 20px;
  height: 20px;
  border-radius: 100%;
  position: relative;
  &:after {
    content: '';
    background-color: #fff;
    position: absolute;
    top: 3px;
    left: 3px;
    width: 14px;
    height: 14px;
    border-radius: 100%;
  }
`;
